import { Action } from '@ngrx/store';

export const CLEAR_VOCABULARY_CACHE_SUCCESS = '[Vocabulary] Clear Vocabulary Cache Success';

export class ClearVocabularyCacheSuccessAction implements Action {
  readonly type = CLEAR_VOCABULARY_CACHE_SUCCESS;

  constructor(public payload: { success: boolean }) {}
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/ClearVocabularyCacheSuccessAction.ts